import styled from 'styled-components'

export const StatusContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: ro;
  align-items: center;
  height: 276px;

  overflow: hidden;
  border: 5px solid #080a0c;

  box-shadow: 0px -1.51406px 4.0375px rgba(255, 255, 255, 0.2),
    0px 12.1125px 20.1875px rgba(0, 0, 0, 0.08), 0px 6.05625px 10.0938px rgba(0, 0, 0, 0.06),
    0px 2.01875px 4.0375px rgba(0, 0, 0, 0.04);

  padding: 0 16px;

  border-radius: 32px;
`
